import { Component, Input, OnInit } from "@angular/core";
import { TimerService } from "./timer.service";
import { JobsStore } from "../../jobs.store";
import { NgStyle, NgIf, NgClass } from "@angular/common";
import { JobTimeTrackingService } from "../job-time-tracking-modal/job-time-tracking.service";
import { DragulaService } from "ng2-dragula";
import { JobsService } from "../../jobs.service";

@Component({
  selector: "app-timer",
  templateUrl: "./timer.component.html",
  styleUrls: ["./timer.component.scss"],
  imports: [NgStyle, NgIf, NgClass],
})
export class TimerComponent implements OnInit {
  @Input() timeTrackingStatus: {
    current_time: number;
    is_paused: boolean;
    job: any;
  };
  job;
  companyAndJob: string;
  openModal: boolean = false;
  isLoading: boolean = true;

  constructor(
    public timerService: TimerService,
    private dragulaService: DragulaService,
    private jobsService: JobsService,
    private jobsStore: JobsStore,
    public jobTimeTrackingService: JobTimeTrackingService,
  ) {}

  async ngOnInit(): Promise<void> {
    this.job = this.timeTrackingStatus.job;
    try {
      this.companyAndJob = `${this.job.client_company.name}: ${this.job.name}`;
      this.timerService.job = this.job;

      const { current_time, is_paused } = this.timeTrackingStatus;
      this.timerService.isPaused = is_paused;
      this.timerService.secondsSignal.set(current_time);

      if (!is_paused) {
        this.timerService.startLocalTimer(current_time);
      }
    } catch (error) {
      console.error("Error during initialization:", error);
    } finally {
      this.isLoading = false;
    }
  }

  async timerResume(): Promise<void> {
    this.isLoading = true;
    try {
      await this.timerService.timerResume();
    } catch (err) {
      console.error("Error resuming timer:", err);
    } finally {
      this.isLoading = false;
    }
  }

  async timerPause(): Promise<void> {
    this.isLoading = true;
    try {
      await this.timerService.timerPause();
    } catch (err) {
      console.error("Error pausing timer:", err);
    } finally {
      this.isLoading = false;
    }
  }

  openStopConfirmationModal(jobName) {
    this.timerService.openStopConfirmationModal(jobName);
  }

  openJobPanel() {
    this.jobsStore.changeSelectedJob.next(this.job);
  }
}
